export enum WorkflowStepLabel {
  FinalApprover = 6,
  ExternalApprover = 8
}
